import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function SearchComponent() {
  const [customerName, setCustomerName] = useState('');
  const [customerNumber, setCustomerNumber] = useState('');
  const [ticketNumber, setTicketNumber] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();

    // Check if at least one field has a value
    if (!customerName.trim() && !customerNumber.trim() && !ticketNumber.trim()) {
      return;
    }

    // Build query parameters
    const params = new URLSearchParams();
    if (customerName.trim()) params.append('customer_name', customerName);
    if (customerNumber.trim()) params.append('customer_number', customerNumber);
    if (ticketNumber.trim()) params.append('ticket_number', ticketNumber);

    navigate(`/search/search?${params.toString()}`);
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col gap-2 shadow-lg bg-white p-4 rounded-lg">
          <div className="flex gap-2 items-center">
            <input
              type="text"
              value={customerName}
              onChange={e => setCustomerName(e.target.value)}
              placeholder="Customer Name"
              className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-400 text-sm"
            />
            <input
              type="text"
              value={customerNumber}
              onChange={e => setCustomerNumber(e.target.value)}
              placeholder="Customer Number"
              className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-400 text-sm"
            />
            <input
              type="text"
              value={ticketNumber}
              onChange={e => setTicketNumber(e.target.value)}
              placeholder="Ticket Number"
              className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-400 text-sm"
            />
            <button
              type="submit"
              className="px-6 py-2 bg-slate-600 text-white font-semibold border-b-4 rounded-lg hover:bg-green-500 border-slate-800 hover:border-green-700 flex items-center whitespace-nowrap"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="size-6"
              >
                <path
                  fillRule="evenodd"
                  d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default SearchComponent;
